export default __webpack_public_path__ + "static/media/img30.46eec61e.jpg";